/**
 * UsernamePickerModal.jsx
 *
 * Shown after Google OAuth when the user has no custom username.
 * Must pick a username before proceeding.
 */

import React, { useState } from "react";
import { supabase } from "../utils/supabase";

const UsernamePickerModal = ({ user, onDone }) => {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const trimmed = username.trim();

    if (!trimmed) {
      setError("Username is required.");
      return;
    }
    if (trimmed.length < 2) {
      setError("Username must be at least 2 characters.");
      return;
    }
    if (!/^[a-zA-Z0-9_]+$/.test(trimmed)) {
      setError("Letters, numbers, and underscores only.");
      return;
    }

    setLoading(true);

    // Check if username is already taken
    const { data: existing } = await supabase
      .from("profiles")
      .select("id")
      .ilike("username", trimmed)
      .neq("id", user.id)
      .single();

    if (existing) {
      setError("That username is already taken.");
      setLoading(false);
      return;
    }

    // Update profile
    const { error: updateErr } = await supabase
      .from("profiles")
      .update({ username: trimmed })
      .eq("id", user.id);

    setLoading(false);

    if (updateErr) {
      setError("Something went wrong. Try again.");
      return;
    }

    onDone(trimmed);
  };

  return (
    <div className="auth-overlay">
      <div className="auth-modal">
        <div className="auth-modal-header">
          <h2
            className="auth-title"
            style={{ color: "var(--gold)" }}
          >
            PICK YOUR USERNAME
          </h2>
          <div className="title-stripe small" />
          <p className="auth-subtitle">
            Choose a display name for the leaderboard
          </p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-label">USERNAME</label>
            <input
              className="auth-input"
              type="text"
              value={username}
              onChange={(e) =>
                setUsername(e.target.value.slice(0, 20))
              }
              placeholder="e.g. mattNFL"
              autoFocus
              required
              maxLength={20}
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button
            className="btn btn-primary"
            type="submit"
            disabled={loading}
            style={{ width: "100%", marginTop: "8px" }}
          >
            {loading ? "PLEASE WAIT..." : "LET'S GO"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UsernamePickerModal;
